export const MICROSITE_LABEL_SETTING={
    type: "text",
    name: "" ,
    title: {
      default: "",
    },
    hideNumber: true,
    isRequired: true,
    requiredErrorText: {
      default: "Field is required",
    },
    validators: [
      {
        type: "expression",
      },
    ],
    placeholder: {
      default: "",
    },
    modalTitle: null,
}